import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-resources",
  "use": "icon-resources-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-resources\"><title>云盘资源</title><g id=\"icon-resources_图层_2\" data-name=\"图层 2\"><g id=\"icon-resources_图层_1-2\" data-name=\"图层 1\"><path d=\"M39.38,31.35,32.43,1.83A2.37,2.37,0,0,0,30.13,0H9.87a2.37,2.37,0,0,0-2.3,1.83L.62,31.35A6,6,0,0,0,6,40H34a6,6,0,0,0,5.38-8.65ZM9.48,4.1A2.77,2.77,0,0,1,12.16,2H27.84a2.77,2.77,0,0,1,2.68,2.1L36.9,28.75A6,6,0,0,0,34,28H6a6,6,0,0,0-2.9.75ZM34,38H6a4,4,0,0,1,0-8H34a4,4,0,0,1,0,8Z\" /><path d=\"M26,33H6a1,1,0,0,0,0,2H26a1,1,0,0,0,0-2Z\" /><circle cx=\"33\" cy=\"34\" r=\"2\" /><path d=\"M13.5,21h13a3.49,3.49,0,0,0,.39-7,5,5,0,0,0-9.52-2.92A3.44,3.44,0,0,0,13,14a3.49,3.49,0,0,0,.45,7Zm.76-6.83a2.78,2.78,0,0,1,2.85-2.23,3.21,3.21,0,0,1,.72.09,4.15,4.15,0,0,1,3.82-2.28,3.91,3.91,0,0,1,4.13,3.65,3.26,3.26,0,0,1-.09.76,2.69,2.69,0,0,1,2.57,2.53,2.74,2.74,0,0,1-2.89,2.56H14.64a2.74,2.74,0,0,1-2.89-2.56A2.68,2.68,0,0,1,14.26,14.17Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/resources.svg
// module id = z+Pz
// module chunks = 35